import axios, {AxiosResponse} from 'axios';

export default class InvoiceInfoClient {
  static getInvoiceInfo(organisationId: string): Promise<AxiosResponse> {
    const requestOptions: object = {
      method: 'GET',
      url: `${process.env.API_URL}/organisation/${organisationId}/invoice-informations`,
    };

    return axios(requestOptions);
  }
}
